/*
Create By POOM : 2023-10-30

 Update By POOM : 30/01/2024  ให้ Weekend , Holiday  ไม่บังคับกรอกแล้ว  สามารถระบุ 00 หรือค่าว่างได้ทั้ง WT , OT
 Update By POOM : 08/05/2024  
                  - เพิ่ม Service OT
                  
 Update By POOM : 2024-05-10  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที
	

*/

import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import Pathurl from "../Class/Pathurl.json";
import { useLocation } from "react-router-dom";


import { Class_ETC_Decrypt 
  , Class_ETC_MsgError
  , Class_ETC_MsgSuccess
  , Class_ETC_MsgErrorfocusByID
  , convertTimeToMinutes
  , Class_ETC_SessionTimeOut
} from "../Class/Class_Etc";

import Select from "react-select";
import ConfigETC from "../Class/ConfigETC.json";
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import "react-datepicker/dist/react-datepicker.css"
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import { customStylesSelect } from "../Class/Class_Etc"
import MsgDescription from "../Class/MsgDescription.json";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimeField } from '@mui/x-date-pickers/TimeField';


function M_company_ae() {

  
  //#region __ Declare __

  const djstext = "2022-04-17T"
  const location = useLocation();
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [configData, setConfigData] = useState([]);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [listStartday, setlistStartday] = useState(null);

  const [pgAct, setPgAct] = useState("");
  const [pgcom_id, setPgcom_id] = useState("0");
  const ddl_startday_refid = useRef(null)

  const [ck_CompanyCode, setck_CompanyCode] = useState("");
  const [comcodeEdit, setcomcodeEdit] = useState("");

  const [TF_Work_WT, setTF_Work_WT] = useState(null);
  const [TF_Work_OT, setTF_Work_OT] = useState(null);
  
  const [TF_Weekend_WT, setTF_Weekend_WT] = useState(null);
  const [TF_Weekend_OT, setTF_Weekend_OT] = useState(null);
  
  const [TF_Holiday_WT, setTF_Holiday_WT] = useState(null);
  const [TF_Holiday_OT, setTF_Holiday_OT] = useState(null);

  const [TF_Work_WT_data, setTF_Work_WT_data] = useState("");
  const [TF_Work_OT_data, setTF_Work_OT_data] = useState("");
  
  const [TF_Weekend_WT_data, setTF_Weekend_WT_data] = useState("");
  const [TF_Weekend_OT_data, setTF_Weekend_OT_data] = useState("");
  
  const [TF_Holiday_WT_data, setTF_Holiday_WT_data] = useState("");
  const [TF_Holiday_OT_data, setTF_Holiday_OT_data] = useState("");

  const [TF_Work_WT_focus, setTF_Work_WT_focus] = useState(false);
  const [TF_Work_OT_focus, setTF_Work_OT_focus] = useState(false);
  
  const [TF_Weekend_WT_focus, setTF_Weekend_WT_focus] = useState(false);
  const [TF_Weekend_OT_focus, setTF_Weekend_OT_focus] = useState(false);
  
  const [TF_Holiday_WT_focus, setTF_Holiday_WT_focus] = useState(false);
  const [TF_Holiday_OT_focus, setTF_Holiday_OT_focus] = useState(false);

  const [isdisabled_rdoday , setIsdisabled_rdoday] = useState(false)

  const [service_day, setService_day] = useState("");
  const [service_day_class, setService_day_class] = useState("");


  const [sw_status, setsw_status] = useState(true);
  const [rdo_monday, setrdo_monday] = useState("1");
  const [rdo_tuesday, setrdo_tuesday] = useState("1");
  const [rdo_wednesday, setrdo_wednesday] = useState("1");
  const [rdo_thursday, setrdo_thursday] = useState("1");
  const [rdo_friday, setrdo_friday] = useState("1");
  const [rdo_saturday, setrdo_saturday] = useState("1");
  const [rdo_sunday, setrdo_sunday] = useState("1");
  const [ddl_startday, setddl_startday] = useState(null);
  const [txt_Service_Start, settxt_Service_Start] = useState("");
  const [txt_Service_End, settxt_Service_End] = useState("");
  const [txt_max_staff, settxt_max_staff] = useState("");

  const [isCheckService, setIsCheckService] = useState({

    cb_department: false,
    cb_ot: false,

  });
  

  //#endregion

  
  //#region __ useEffect __

  useEffect(() => {
    let supportsystem = localStorage.getItem("supportsystem");
    if (supportsystem === "allowcom0") {
      GetParameter(function() {
        if (pgAct !== "")
        {
          setlistStartday(ReturnListStartday);
          GetConfig();
          if (isLoadedConfigData === true) {
            // ถ้าเป็น Edit จะ Bind Comid ของตัวเอง ถ้าเป็น Add จะต้อง Bind Com 0 มาแสดง ตั้งต้นให้
            BindData(function() {
              setIsLoadProgress(false)
            });
          }
        }
      });
    }
    else {
      window.location.replace("../" + Pathurl.no_permission);
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData , pgAct]);


  //#endregion

  
  //#region __ Function __

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  function ReturnListStartday(){
    let ValueReturn = [];

    for (let i = 0 ; i < 28 ; i++)
    {
      ValueReturn.push({ value: (i + 1).toString(), label: (i + 1).toString() })
    }

    return ValueReturn;
    
  }

  function GetParameter(_callback) {
    let isNullParameter = false;
    let comid = "0";
    let act = "";

    try {
      if (location.state === null) {
        isNullParameter = true;
      } else {
        comid = Class_ETC_Decrypt(location.state?.comid.toString());
        act = Class_ETC_Decrypt(location.state?.act.toString());

        if (act === "") {
          isNullParameter = true;
        } else if (act !== "Add" && act !== "Edit") {
          isNullParameter = true;
        } else {
          if (act === "Edit" && comid === "") {
            isNullParameter = true;
          }
        }
      }
    } catch {
      isNullParameter = true;
    }


    if (isNullParameter) {
      //window.location.replace("../" + Pathurl.m_company);
      if (_callback != null) {
          _callback();
      }
    } else {
      setPgcom_id(comid);
      setPgAct(act);
      if (_callback != null) {
          _callback();
      }
    }
  }

  async function BindData(_callback){

    try {

      
      document.getElementById("txt_Service_Start").value = "";
      document.getElementById("txt_Service_End").value = "";
      settxt_Service_Start(null);
      settxt_Service_End(null);
      
      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      
      var raw = JSON.stringify({
        "com_id": pgcom_id.toString()
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Company_GetData",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {

          setck_CompanyCode("")

          if (pgAct === "Edit")
          {

            if (pgcom_id === "0") {
              setIsdisabled_rdoday(false)
            }
            else{
              setIsdisabled_rdoday(true)
            }

            setcomcodeEdit(json.com_code);
            document.getElementById("txt_Company_Code").value = json.com_code
            document.getElementById("txt_Company_name").value = json.com_name
            document.getElementById("txt_Display_name").value = json.com_display
              
            document.getElementById("txt_Service_Start").value = json.service_start;
            document.getElementById("txt_Service_End").value = json.service_end;

            settxt_Service_Start(json.service_start);
            settxt_Service_End(json.service_end);
            
            settxt_max_staff(json.max_staff.toString());
            setddl_startday({ value: json.start_day.toString(), label: json.start_day.toString() });

            if (json.service !== "")
            {
              let servicearry = json.service.split(",");
              let cb_servicearry = {}; // ประกาศตัวแปร Array 
              servicearry.forEach((item) => { // ประกาศ Loop 
                cb_servicearry["cb_" + item] = true; // ประกาศค่าที่ได้มาทั้งหมด ตาม ID ให้เป็น True 
              });

              setIsCheckService((prevState) => {
                let cb_update = { ...prevState };           
                Object.keys(cb_servicearry).forEach((key) => {
                  if (cb_update.hasOwnProperty(key)) {
                    cb_update[key] = cb_servicearry[key];
                  }
                });      
                return cb_update;
              });
            }
            else {
              const clearCheckboxes = {};
              Object.keys(isCheckService).forEach((key) => {
                clearCheckboxes[key] = false;     
              });
              setIsCheckService(clearCheckboxes);
            }

            setService_day(json.service_day)
            setService_day_class(json.service_day_class)

          }
          else
          {
            
            setIsdisabled_rdoday(false)
            setcomcodeEdit("");
            document.getElementById("txt_Company_Code").value = ""
            document.getElementById("txt_Company_name").value = ""
            document.getElementById("txt_Display_name").value = ""
              
            document.getElementById("txt_max_staff").value = ""
            setddl_startday(null);
            
            const clearCheckboxes = {};
            Object.keys(isCheckService).forEach((key) => {
              clearCheckboxes[key] = false;     
            });
            setIsCheckService(clearCheckboxes);
          }
          
          setTF_Work_WT((json.workday_WT === "" ? null : dayjs(djstext + json.workday_WT)))
          setTF_Work_OT((json.workday_OT === "" ? null : dayjs(djstext + json.workday_OT)))
          setTF_Work_WT_data(json.workday_WT)
          setTF_Work_OT_data(json.workday_OT)


          setTF_Weekend_WT((json.weekend_WT === "" ? null : dayjs(djstext + json.weekend_WT)))
          setTF_Weekend_OT((json.weekend_OT === "" ? null : dayjs(djstext + json.weekend_OT)))
          setTF_Weekend_WT_data(json.weekend_WT)
          setTF_Weekend_OT_data(json.weekend_OT)

          setTF_Holiday_WT((json.holiday_WT === "" ? null : dayjs(djstext + json.holiday_WT)))
          setTF_Holiday_OT((json.holiday_OT === "" ? null : dayjs(djstext + json.holiday_OT)))
          setTF_Holiday_WT_data(json.holiday_WT)
          setTF_Holiday_OT_data(json.holiday_OT)
          
          setsw_status((json.com_status === 1 ?  true : false));
          setrdo_monday(json.day_Mon.toString());
          setrdo_tuesday(json.day_Tue.toString());
          setrdo_wednesday(json.day_Wed.toString());
          setrdo_thursday(json.day_Thu.toString());
          setrdo_friday(json.day_Fri.toString());
          setrdo_saturday(json.day_Sat.toString());
          setrdo_sunday(json.day_Sun.toString());

          if (_callback != null) {
              _callback();
          }
        } else {
          window.location.replace("../" + Pathurl.m_company);
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        window.location.replace("../" + Pathurl.m_company);
      }
    } catch {
      window.location.replace("../" + Pathurl.m_company);
    }

  }

  async function Company_CheckComcode(_callback){

    
    try {
      
      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      
      var raw = JSON.stringify({
        "com_code": document.getElementById("txt_Company_Code").value.trim(),
        "com_id": (pgAct === "Edit" ? pgcom_id : "-1")
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Company_CheckComcode",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          if (json.result_check === 1) {
            setck_CompanyCode("used")
          }
          else {
            setck_CompanyCode("Unavailable")
          }
        } else {
          setck_CompanyCode("Unavailable")
        }
        
        if (_callback != null) {
          _callback();
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        Class_ETC_MsgError(json.status_Desc, null);
        setck_CompanyCode("Unavailable")
        
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setck_CompanyCode("")
      if (_callback != null) {
          _callback();
      }
    }

  }

  function ddlFocas(){

    ddl_startday_refid.current?.focus()

  }

  async function SaveCompany()
  {

    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      
      let com_code = document.getElementById("txt_Company_Code").value.trim()
      let com_name = document.getElementById("txt_Company_name").value.trim()
      let com_display = document.getElementById("txt_Display_name").value.trim();
      
      let workday_WT = convertTimeToMinutes(TF_Work_WT_data); workday_WT = isNaN(workday_WT)  ? "0" : workday_WT;
      let workday_OT = convertTimeToMinutes(TF_Work_OT_data); workday_OT = isNaN(workday_OT)  ? "0": workday_OT;
      let weekend_WT = convertTimeToMinutes(TF_Weekend_WT_data); weekend_WT = isNaN(weekend_WT)  ? "0": weekend_WT;
      let weekend_OT = convertTimeToMinutes(TF_Weekend_OT_data); weekend_OT = isNaN(weekend_OT)  ? "0": weekend_OT;
      let holiday_WT = convertTimeToMinutes(TF_Holiday_WT_data); holiday_WT = isNaN(holiday_WT)  ? "0": holiday_WT;
      let holiday_OT = convertTimeToMinutes(TF_Holiday_OT_data); holiday_OT = isNaN(holiday_OT)  ? "0": holiday_OT;


      let service_start = document.getElementById("txt_Service_Start").value.trim()
      let service_end = document.getElementById("txt_Service_End").value.trim()

      let cbService = Object.entries(isCheckService)
      .filter(([, checked]) => checked)
      .map(([id]) => id.replace("cb_", ""));
      let Service_list = cbService.join(",");


      let startday = ""
      if (ddl_startday !== null) {
        startday = ddl_startday.value
      }

      var raw;
      if (pgAct === "Add")
      {
        raw = JSON.stringify({
          "com_code": com_code,
          "com_name": com_name,
          "com_display": com_display,
          "workday_WT": workday_WT.toString(),
          "weekend_WT": weekend_WT.toString(),
          "holiday_WT": holiday_WT.toString(),
          "workday_OT": workday_OT.toString(),
          "weekend_OT": weekend_OT.toString(),
          "holiday_OT": holiday_OT.toString(),
          "day_Mon": rdo_monday,
          "day_Tue": rdo_tuesday,
          "day_Wed": rdo_wednesday,
          "day_Thu": rdo_thursday,
          "day_Fri": rdo_friday,
          "day_Sat": rdo_saturday,
          "day_Sun": rdo_sunday,
          "com_status": (sw_status === true ? "1" : "0"),
          "service_start": service_start,
          "service_end": service_end,
          "start_day": startday,
          "max_staff": txt_max_staff,
          "service": Service_list
        });
      }
      else
      {
        raw = JSON.stringify({
          "com_id": pgcom_id,
          "com_code": com_code,
          "com_name": com_name,
          "com_display": com_display,
          "workday_WT": workday_WT.toString(),
          "weekend_WT": weekend_WT.toString(),
          "holiday_WT": holiday_WT.toString(),
          "workday_OT": workday_OT.toString(),
          "weekend_OT": weekend_OT.toString(),
          "holiday_OT": holiday_OT.toString(),
          "day_Mon": rdo_monday,
          "day_Tue": rdo_tuesday,
          "day_Wed": rdo_wednesday,
          "day_Thu": rdo_thursday,
          "day_Fri": rdo_friday,
          "day_Sat": rdo_saturday,
          "day_Sun": rdo_sunday,
          "com_status": (sw_status === true ? "1" : "0"),
          "service_start": service_start,
          "service_end": service_end,
          "start_day": startday,
          "max_staff": txt_max_staff,
          "service": Service_list
        });
      }

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + (pgAct === "Add" ? "Company_Add" : "Company_Edit"),
        requestOptions
      );

      const json = await response.json();

      if (json.status_ID === 1) {
        setIsLoadProgress(false);
        Class_ETC_MsgSuccess(MsgDescription.CFM001, GotoCompany);
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      } 
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }

  }

  function GotoCompany(){
    window.location.replace("../" + Pathurl.m_company);
  }

  function on_FocasByMsg()
  {
      let act = document.getElementById("hd_msgfocus").value;
      if (act === "work_day_WT")
      {
        setTF_Work_WT_focus(true);
        setTimeout(() => {
          setTF_Work_WT_focus(false);
        }, 10000);
      }
      else if (act === "weekend_WT")
      {
        setTF_Weekend_WT_focus(true);
        setTimeout(() => {
          setTF_Weekend_WT_focus(false);
        }, 10000);
      }
      else if (act === "holiday_WT")
      {
        setTF_Holiday_WT_focus(true);
        setTimeout(() => {
          setTF_Holiday_WT_focus(false);
        }, 10000);
      }
      
  }



  //#endregion

  
  //#region __ Event __

  const onChange_Radio = (e , act ) => {
    if (act === "Monday")
    {
      setrdo_monday(e.target.value)
    }
    else if (act === "Tuesday")
    {
      setrdo_tuesday(e.target.value)
    }
    else if (act === "Wednesday")
    {
      setrdo_wednesday(e.target.value)
    }
    else if (act === "Thursday")
    {
      setrdo_thursday(e.target.value)
    }
    else if (act === "Friday")
    {
      setrdo_friday(e.target.value)
    }
    else if (act === "Saturday")
    {
      setrdo_saturday(e.target.value)
    }
    else
    {
      setrdo_sunday(e.target.value)
    }
  }
  
  const onChange_cbService = (event) => {
    const { id, checked } = event.target;
    setIsCheckService((prevValues) => ({
      ...prevValues,
      [id]: checked,
    }));
  }
  
  const handleChangetxtMaxStaff =(evt)=>{
    const MaxStaff = (evt.target.validity.valid) ? evt.target.value : txt_max_staff;
    settxt_max_staff(MaxStaff)
  }

  function onClick_CheckComCode(){

    if (document.getElementById("txt_Company_Code").value.trim() === "") {
      Class_ETC_MsgErrorfocusByID(MsgDescription.ERR029, "txt_Company_Code");
    }
    else {
      setIsLoadProgress(true)
      Company_CheckComcode(function(){
        setIsLoadProgress(false)
      });

    }
  }

  function onclick_Cancel(){
    
    setIsLoadProgress(true);
    BindData(function(){
      setIsLoadProgress(false);
    });

  }

  function onblue_time(e , act) {

    let data = e.target.value;
    data = data.replace("h", "0");
    data = data.replace("h", "0");
    data = data.replace("m", "0");
    data = data.replace("m", "0");
    
    if (act === "work_wt")
    {
      setTF_Work_WT_data(data)
      setTF_Work_WT_focus(false)
    }
    else if (act === "work_ot")
    {
      setTF_Work_OT_data(data)
      setTF_Work_OT_focus(false)
    }
    else if (act === "weekend_wt")
    {
      setTF_Weekend_WT_data(data)
      setTF_Weekend_WT_focus(false)
    }
    else if (act === "weekend_ot")
    {
      setTF_Weekend_OT_data(data)
      setTF_Weekend_OT_focus(false)
    }
    else if (act === "holiday_wt")
    {
      setTF_Holiday_WT_data(data)
      setTF_Holiday_WT_focus(false)
    }
    else if (act === "holiday_ot")
    {
      setTF_Holiday_OT_data(data)
      setTF_Holiday_OT_focus(false)
    }
    
  }

  function onClick_Save() {


    setIsLoadProgress(true);
    if (document.getElementById("txt_Company_Code").value.trim() === "")
    {
      setIsLoadProgress(false);
      Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001 , "txt_Company_Code");
    }
    else
    {

      let ischeckcomcode = false
      if (pgAct === "Edit"){
        if (document.getElementById("txt_Company_Code").value.trim() === comcodeEdit)
        {
          ischeckcomcode = true;
        }
        else if (ck_CompanyCode === "used") {
          ischeckcomcode = true;
        }
      }
      else {
        if (ck_CompanyCode === "used") {
          ischeckcomcode = true;
        }
      }
      
      if (ischeckcomcode === false)
      {
        setIsLoadProgress(false);
        Class_ETC_MsgError(ck_CompanyCode === "Unavailable" ? MsgDescription.ERR031 : MsgDescription.ERR030 , null);
      }
      else {
        
        let workday_WT = convertTimeToMinutes(TF_Work_WT_data); workday_WT = isNaN(workday_WT)  ? "0" : workday_WT;
        let workday_OT = convertTimeToMinutes(TF_Work_OT_data); workday_OT = isNaN(workday_OT)  ? "0": workday_OT;
        let weekend_WT = convertTimeToMinutes(TF_Weekend_WT_data); weekend_WT = isNaN(weekend_WT)  ? "0": weekend_WT;
        let weekend_OT = convertTimeToMinutes(TF_Weekend_OT_data); weekend_OT = isNaN(weekend_OT)  ? "0": weekend_OT;
        let holiday_WT = convertTimeToMinutes(TF_Holiday_WT_data); holiday_WT = isNaN(holiday_WT)  ? "0": holiday_WT;
        let holiday_OT = convertTimeToMinutes(TF_Holiday_OT_data); holiday_OT = isNaN(holiday_OT)  ? "0": holiday_OT;

        let istxtError = "";


        if (document.getElementById("txt_Company_name").value.trim() === "")
        {
          istxtError = "txt_Company_name";
        }
        else if (document.getElementById("txt_Display_name").value.trim() === "")
        {
          istxtError = "txt_Display_name";
        }
        //////////////////// WORKTIMECHECK /////////////////////////
        else if (TF_Work_WT_data === "" && TF_Work_OT_data === "") 
        {
          istxtError = "work_day_WT_";
        }
        else if (TF_Work_WT_data === "00:00" && TF_Work_OT_data === "00:00") 
        {
          istxtError = "work_day_WT>";
        }
        else if (workday_WT < 1 && workday_OT < 1) 
        {
          istxtError = "work_day_WT>";
        }
        else if (parseInt(workday_WT) + parseInt(workday_OT) > 1440)
        {
          istxtError = "work_day_WT";
        } 
        //////////////////// WEEKENDCHECK /////////////////////////
        // else if (TF_Weekend_WT_data === "" && TF_Weekend_OT_data === "") 
        // {
        //   istxtError = "weekend_WT_";
        // }   
        // else if (TF_Weekend_WT_data === "00:00" && TF_Weekend_OT_data === "00:00")  
        // {
        //   istxtError = "weekend_WT>";
        // }  
        // else if (weekend_WT < 1 && weekend_OT < 1) 
        // {
        //   istxtError = "weekend_WT>";
        // }
        else if (parseInt(weekend_WT) + parseInt(weekend_OT) > 1440)
        {
          istxtError = "weekend_WT";
        }
        //////////////////// HOLIDAYCHECK /////////////////////////
        // else if (TF_Holiday_WT_data === "" && TF_Holiday_OT_data === "") 
        // {
        //   istxtError = "holiday_WT_";
        // } 
        // else if (TF_Holiday_WT_data === "00:00" && TF_Holiday_OT_data === "00:00")  
        // {
        //   istxtError = "holiday_WT>";
        // } 
        // else if (holiday_WT < 1 && holiday_OT < 1) 
        // {
        //   istxtError = "holiday_WT>";
        // }
        else if (parseInt(holiday_WT) + parseInt(holiday_OT) > 1440)
        {
          istxtError = "holiday_WT";
        }
        else if (document.getElementById("txt_Service_Start").value.trim() === "")
        {
          istxtError = "txt_Service_Start";
        }
        else if (document.getElementById("txt_Service_End").value.trim() === "")
        {
          istxtError = "txt_Service_End";
        }
        else if (ddl_startday === null)
        {
          istxtError = "ddl_startday";
        }
        else if (txt_max_staff === "")
        {
          istxtError = "txt_max_staff";
        }


        if (istxtError !== "")
        {
          
          if (istxtError === "work_day_WT_" || istxtError === "weekend_WT_"|| istxtError === "holiday_WT_") 
          {
            setIsLoadProgress(false);
            document.getElementById("hd_msgfocus").value = istxtError.slice(0, -1);
            Class_ETC_MsgError(MsgDescription.ERR001, on_FocasByMsg);
          }
          else if (istxtError === "work_day_WT>" || istxtError === "weekend_WT>"|| istxtError === "holiday_WT>") 
          {
            setIsLoadProgress(false);
            document.getElementById("hd_msgfocus").value = istxtError.slice(0, -1);
            Class_ETC_MsgError(MsgDescription.ERR018, on_FocasByMsg);
          }
          else if (istxtError === "work_day_WT" || istxtError === "weekend_WT" || istxtError === "holiday_WT") 
          {
            setIsLoadProgress(false);
            document.getElementById("hd_msgfocus").value = istxtError;
            Class_ETC_MsgError(MsgDescription.ERR020, on_FocasByMsg);
          } 
          else if (istxtError === "ddl_startday")
          {
            setIsLoadProgress(false);
            Class_ETC_MsgError(MsgDescription.ERR001, ddlFocas);
          }
          else
          {
            setIsLoadProgress(false);
            Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001, istxtError);
          }    
        }
        else
        {
          SaveCompany();
        }
      }
    }
    
  }

  
  //#endregion



  return (
    <>
      <Helmet>
        <title>Company</title>
      </Helmet>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <div className="content-wrapper">
        <div className="content-header">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="container-fluid">
                <div className="text-center">
                  {" "}
                  <h1>
                    <i className="fas fa-store-alt" /> Company{" "}
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="card  shadow">
                  <div className="card-header">
                    <h3 className="card-title text-bold"> 
                      Company setting
                    </h3>
                  </div>
                  <div className="card-body mb-0">
                    <div className="form-horizontal">
                      <div className="form-group row">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Company Code<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-4">

                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control form-control-sm text-bold"
                              placeholder="Company Code"
                              id="txt_Company_Code"
                            />

                            <div className="input-group-append">
                              <button
                                type="submit"
                                className="btn btn-default btn-sm"
                                title="Check for duplicate Login Code"
                                onClick={onClick_CheckComCode}
                              >
                                <i className="fas fa-search" /> Check duplicate
                              </button>
                            </div>

                          </div>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            {ck_CompanyCode === "used" && 
                              <>
                                <span className="text-green">
                                  <i className="fas fa-check" /> Can be used
                                </span>
                              </>
                            }
                            {ck_CompanyCode === "Unavailable" && 
                              <>
                                <span className="text-red">
                                  <i className="fas fa-times" /> Unavailable
                                </span>
                              </>
                            }
                          </span>
                        </div>

                      </div>

                      <div className="form-group row">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Company name<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Display name"
                            id="txt_Company_name"
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Display name<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Display name"
                            id="txt_Display_name"
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                            <label className="text-sm col-sm-2 col-form-label text-right">
                              Status{" "}
                            </label>
                            <div className="col-sm-10">
                              <BootstrapSwitchButton 
                                onChange={(checked) => {setsw_status(checked)}}
                                checked={sw_status}
                                width={ConfigETC.SwitchButton_in_active_width} 
                                onlabel={ConfigETC.SwitchButton_active_text}
                                onstyle={ConfigETC.SwitchButton_active_color}
                                offlabel={ConfigETC.SwitchButton_inactive_text}
                                offstyle={ConfigETC.SwitchButton_inactive_color}
                                size="xs"
                              /> 
                            </div>
                      </div>
                        
                      <hr>
                      </hr>
                      <div className="row">
                        <div className="col-lg-6 col-12">


                          <div className="row mb-1">
                            <div className="col-sm-4 text-small">
                              <span> &nbsp; </span>
                            </div>
                            <div className="col-sm-4 text-small text-left">
                              <span> <i
                                      className="far fa-clock"
                                      title="Work time"
                                    />
                                    &nbsp;WT{" "} </span>
                            </div>
                            <div className="col-sm-4 text-small text-ledt">
                              <span>  <i
                                      className="far fa-lightbulb"
                                      title="Over time"
                                    />
                                    &nbsp;OT{" "} </span>
                            </div>
                          </div>
                          <div className="form-group row mb-2">
                            <input id="hd_msgfocus" type="hidden" ></input>
                            <label className="text-sm col-sm-4 col-form-label text-right">
                              Work day<span className="text-danger">*</span>
                              <small>(hr./day)</small>{" "}
                            </label>
                            <div className="col-sm-4">
                              <div className="input-group">
                                {((pgAct === "Add" || pgcom_id === "0") &&
                                  <>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <TimeField ampm={false}  
                                        error={false}
                                        size="small"
                                        value={TF_Work_WT}
                                        onChange={(e) => {setTF_Work_WT(e)}}
                                        onBlur={(e) => onblue_time(e , "work_wt")}
                                        focused={TF_Work_WT_focus}
                                      />
                                    </LocalizationProvider>
                                  </>
                                ) ||
                                (
                                  <ShowTimeLabel time={TF_Work_WT_data} ></ShowTimeLabel>
                                )
                                }
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="input-group">
                                {((pgAct === "Add" || pgcom_id === "0") &&
                                    <>
                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimeField ampm={false}  
                                          error={false}
                                          size="small"
                                          value={TF_Work_OT}
                                          onChange={(e) => {setTF_Work_OT(e)}}
                                          onBlur={(e) => onblue_time(e , "work_ot")}
                                          focused={TF_Work_OT_focus}
                                        />
                                      </LocalizationProvider>
                                    </>
                                  ) ||
                                  (
                                    <ShowTimeLabel time={TF_Work_OT_data} ></ShowTimeLabel>
                                  )
                                  }
                              </div>
                            </div>
                          </div>

                          <div className="form-group row mb-2">
                            <label className="text-sm col-sm-4 col-form-label text-right">
                              Weekend<span className="text-danger">*</span>{" "}
                              <small>(hr./day)</small>
                            </label>
                            <div className="col-sm-4">
                              <div className="input-group">
                                {((pgAct === "Add" || pgcom_id === "0") &&
                                    <>
                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimeField ampm={false}  
                                          error={false}
                                          size="small"
                                          value={TF_Weekend_WT}
                                          onChange={(e) => {setTF_Weekend_WT(e)}}
                                          onBlur={(e) => onblue_time(e , "weekend_wt")}
                                          focused={TF_Weekend_WT_focus}
                                        />
                                      </LocalizationProvider>
                                    </>
                                  ) ||
                                  (
                                    <ShowTimeLabel time={TF_Weekend_WT_data} ></ShowTimeLabel>
                                  )
                                  }
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="input-group">
                                {((pgAct === "Add" || pgcom_id === "0") &&
                                    <>
                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimeField ampm={false}  
                                          error={false}
                                          size="small"
                                          value={TF_Weekend_OT}
                                          onChange={(e) => {setTF_Weekend_OT(e)}}
                                          onBlur={(e) => onblue_time(e , "weekend_ot")}
                                          focused={TF_Weekend_OT_focus}
                                        />
                                      </LocalizationProvider>
                                    </>
                                  ) ||
                                  (
                                    <ShowTimeLabel time={TF_Weekend_OT_data} ></ShowTimeLabel>
                                  )
                                  }
                              </div>
                            </div>
                          </div>

                         
                          <div className="form-group row">
                            <label className="text-sm col-sm-4 col-form-label text-right">
                              Holiday <small>(hr./day)</small>
                            </label>
                            <div className="col-sm-4">
                              <div className="input-group">
                                {((pgAct === "Add" || pgcom_id === "0") &&
                                    <>
                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimeField ampm={false}  
                                          error={false}
                                          size="small"
                                          value={TF_Holiday_WT}
                                          onChange={(e) => {setTF_Holiday_WT(e)}}
                                          onBlur={(e) => onblue_time(e , "holiday_wt")}
                                          focused={TF_Holiday_WT_focus}
                                        />
                                      </LocalizationProvider>
                                    </>
                                  ) ||
                                  (
                                    <ShowTimeLabel time={TF_Holiday_WT_data} ></ShowTimeLabel>
                                  )
                                  }
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="input-group">
                                {((pgAct === "Add" || pgcom_id === "0") &&
                                    <>
                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimeField ampm={false}  
                                          error={false}
                                          size="small"
                                          value={TF_Holiday_OT}
                                          onChange={(e) => {setTF_Holiday_OT(e)}}
                                          onBlur={(e) => onblue_time(e , "holiday_ot")}
                                          focused={TF_Holiday_OT_focus}
                                        />
                                      </LocalizationProvider>
                                    </>
                                  ) ||
                                  (
                                    <ShowTimeLabel time={TF_Holiday_OT_data} ></ShowTimeLabel>
                                  )
                                  }
                              </div>
                            </div>
                          </div>
                          
                        </div>
                        {/* Mon - Sun */}
                        <div className="col-lg-6 col-12">
                          <div className="form-group row m-0">
                            <label className="text-sm col-sm-4  text-right">
                              Monday
                            </label>
                            <div className="col-sm-4">
                              <div className="form-group clearfix p-0">
                                <div className="icheck-primary d-inline">
                                  
                                  <input
                                    type="radio"
                                    id="rdo_work_Monday"
                                    value="1"
                                    disabled={isdisabled_rdoday}
                                    checked={rdo_monday === "1"}
                                    onChange={(e) => onChange_Radio(e , "Monday")} 
                                  />
                                  <label htmlFor="rdo_work_Monday">
                                    <span><small>Work day</small></span>
                                  </label>

                                </div>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="icheck-primary d-inline">
                                
                                <input
                                  type="radio"
                                  id="rdo_weekend_Monday"
                                  value="0"
                                  disabled={isdisabled_rdoday}
                                  checked={rdo_monday === "0"}
                                  onChange={(e) => onChange_Radio(e , "Monday")} 
                                />
                                <label htmlFor="rdo_weekend_Monday">
                                  <span>
                                    <small>Weekend</small>
                                  </span>
                                </label>

                              </div>
                            </div>
                          </div>
                          <div className="form-group row m-0">
                            <label className="text-sm col-sm-4  text-right">
                              Tuesday
                            </label>
                            <div className="col-sm-4">
                              <div className="form-group clearfix p-0">
                                <div className="icheck-primary d-inline">
                                  
                                  <input
                                    type="radio"
                                    id="rdo_work_Tuesday"
                                    value="1"
                                    disabled={isdisabled_rdoday}
                                    checked={rdo_tuesday === "1"}
                                    onChange={(e) => onChange_Radio(e , "Tuesday")} 
                                  />
                                  <label htmlFor="rdo_work_Tuesday">
                                    <span>
                                      <small>Work day</small>
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="icheck-primary d-inline">
                                
                                <input
                                  type="radio"
                                  id="rdo_weekend_Tuesday"
                                  value="0"
                                  disabled={isdisabled_rdoday}
                                  checked={rdo_tuesday === "0"}
                                  onChange={(e) => onChange_Radio(e , "Tuesday")} 
                                />
                                <label htmlFor="rdo_weekend_Tuesday">
                                  <span>
                                    <small>Weekend</small>
                                  </span>
                                </label>

                              </div>
                            </div>
                          </div>
                          <div className="form-group row m-0">
                            <label className="text-sm col-sm-4  text-right">
                              Wednesday
                            </label>
                            <div className="col-sm-4">
                              <div className="form-group clearfix p-0">
                                <div className="icheck-primary d-inline">
                                  
                                  
                                  <input
                                    type="radio"
                                    id="rdo_work_Wednesday"
                                    value="1"
                                    disabled={isdisabled_rdoday}
                                    checked={rdo_wednesday === "1"}
                                    onChange={(e) => onChange_Radio(e , "Wednesday")} 
                                  />
                                  <label htmlFor="rdo_work_Wednesday">
                                    <span>
                                      <small>Work day</small>
                                    </span>
                                  </label>

                                </div>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="icheck-primary d-inline">
                                
                                
                                <input
                                  type="radio"
                                  id="rdo_Weekend_Wednesday"
                                  value="0"
                                  disabled={isdisabled_rdoday}
                                  checked={rdo_wednesday === "0"}
                                  onChange={(e) => onChange_Radio(e , "Wednesday")} 
                                />
                                <label htmlFor="rdo_Weekend_Wednesday">
                                  <span>
                                    <small>Weekend</small>
                                  </span>
                                </label>

                              </div>
                            </div>
                          </div>
                          <div className="form-group row m-0">
                            <label className="text-sm col-sm-4  text-right">
                              Thursday
                            </label>
                            <div className="col-sm-4">
                              <div className="form-group clearfix p-0">
                                <div className="icheck-primary d-inline">
                                  
                                  
                                  <input
                                    type="radio"
                                    id="rdo_Work_Thursday"
                                    value="1"
                                    disabled={isdisabled_rdoday}
                                    checked={rdo_thursday === "1"}
                                    onChange={(e) => onChange_Radio(e , "Thursday")} 
                                  />
                                  <label htmlFor="rdo_Work_Thursday">
                                    <span>
                                      <small>Work day</small>
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="icheck-primary d-inline">
                                
                                
                                <input
                                  type="radio"
                                  id="rdo_Weekend_Thursday"
                                  value="0"
                                  disabled={isdisabled_rdoday}
                                  checked={rdo_thursday === "0"}
                                  onChange={(e) => onChange_Radio(e , "Thursday")} 
                                />
                                <label htmlFor="rdo_Weekend_Thursday">
                                  <span>
                                    <small>Weekend</small>
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="form-group row m-0">
                            <label className="text-sm col-sm-4  text-right">
                              Friday
                            </label>
                            <div className="col-sm-4">
                              <div className="form-group clearfix p-0">
                                <div className="icheck-primary d-inline">
                                  
                                  
                                  <input
                                    type="radio"
                                    id="rdo_Work_Friday"
                                    value="1"
                                    disabled={isdisabled_rdoday}
                                    checked={rdo_friday === "1"}
                                    onChange={(e) => onChange_Radio(e , "Friday")} 
                                  />
                                  <label htmlFor="rdo_Work_Friday">
                                    <span>
                                      <small>Work day</small>
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="icheck-primary d-inline">
                                
                                
                                <input
                                  type="radio"
                                  id="rdo_Weekend_Friday"
                                  value="0"
                                  disabled={isdisabled_rdoday}
                                  checked={rdo_friday === "0"}
                                  onChange={(e) => onChange_Radio(e , "Friday")} 
                                />
                                <label htmlFor="rdo_Weekend_Friday">
                                  <span>
                                    <small>Weekend</small>
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="form-group row m-0">
                            <label className="text-sm col-sm-4  text-right">
                              Saturday
                            </label>
                            <div className="col-sm-4">
                              <div className="form-group clearfix p-0">
                                <div className="icheck-primary d-inline">
                                  
                                  
                                  <input
                                    type="radio"
                                    id="rdo_Work_Saturday"
                                    value="1"
                                    disabled={isdisabled_rdoday}
                                    checked={rdo_saturday === "1"}
                                    onChange={(e) => onChange_Radio(e , "Saturday")} 
                                  />
                                  <label htmlFor="rdo_Work_Saturday">
                                    <span>
                                      <small>Work day</small>
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="icheck-primary d-inline">
                                
                                
                                <input
                                  type="radio"
                                  id="rdo_Weekend_Saturday"
                                  value="0"
                                  disabled={isdisabled_rdoday}
                                  checked={rdo_saturday === "0"}
                                  onChange={(e) => onChange_Radio(e , "Saturday")} 
                                />
                                <label htmlFor="rdo_Weekend_Saturday">
                                  <span>
                                    <small>Weekend</small>
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="form-group row m-0">
                            <label className="text-sm col-sm-4  text-right">
                              Sunday
                            </label>
                            <div className="col-sm-4">
                              <div className="form-group clearfix p-0">
                                <div className="icheck-primary d-inline">
                                  
                                  
                                  <input
                                    type="radio"
                                    id="rdo_Work_Sunday"
                                    value="1"
                                    disabled={isdisabled_rdoday}
                                    checked={rdo_sunday === "1"}
                                    onChange={(e) => onChange_Radio(e , "Sunday")} 
                                  />
                                  <label htmlFor="rdo_Work_Sunday">
                                    <span>
                                      <small>Work day</small>
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="icheck-primary d-inline">
                                
                                
                                <input
                                  type="radio"
                                  id="rdo_Weekend_Sunday"
                                  value="0"
                                  disabled={isdisabled_rdoday}
                                  checked={rdo_sunday === "0"}
                                  onChange={(e) => onChange_Radio(e , "Sunday")} 
                                />
                                <label htmlFor="rdo_Weekend_Sunday">
                                  <span>
                                    <small>Weekend</small>
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-header">
                    <h3 className="card-title text-bold"> Company Service
                    {"        "}
                    {(pgAct === "Edit" && service_day !== "") && 
                      <>
                        <span
                          className={service_day_class}
                          data-toggle="tooltip"
                          title="Expires within"
                        >
                          {" "}
                          {service_day}
                        </span>
                      </>
                    }
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="form-horizontal">
                      <div className="form-group row">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Service Start<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <DatePickerComponent
                              id="txt_Service_Start"
                              value={txt_Service_Start}
                              format="dd/MM/yyyy"
                              strictMode={true}
                            />
                          </div>
                        </div>
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Service End<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <DatePickerComponent
                              id="txt_Service_End"
                              value={txt_Service_End}
                              format="dd/MM/yyyy"
                              strictMode={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Start day<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-4">
                          <Select
                            ref={ddl_startday_refid}
                            options={listStartday}
                            placeholder={ConfigETC.ddl_pleaseselect}
                            isClearable={true}
                            menuPortalTarget={document.body}
                            onChange={(e) => setddl_startday(e)}
                            value={ddl_startday}
                            styles={customStylesSelect}
                            size="small"
                          />
                        </div>
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Max Staff<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-4">
                          <input
                            type="text"
                            id="txt_max_staff"
                            className="form-control"
                            pattern="[0-9]*"
                            onInput={handleChangetxtMaxStaff} 
                            value={txt_max_staff}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Service
                        </label>
                        <div className="col-sm-4">

                          <div className="form-group clearfix pt-1">
                            <div className="icheck-primary d-inline">
                              <input
                                id="cb_department"
                                className="form-check-input"
                                type="checkbox"
                                checked={isCheckService.cb_department}
                                onChange={onChange_cbService}

                              />
                              <label htmlFor="cb_department">
                                <span className="text-normal">Department</span>
                              </label>
                            </div>
                          </div>

                          <div className="form-group clearfix pt-1">
                            <div className="icheck-primary d-inline">
                              <input
                                id="cb_ot"
                                className="form-check-input"
                                type="checkbox"
                                checked={isCheckService.cb_ot}
                                onChange={onChange_cbService}

                              />
                              <label htmlFor="cb_ot">
                                <span className="text-normal">OT</span>
                              </label>
                            </div>
                          </div>

                        </div>


                      </div>
                      


                    </div>
                  </div>
                  <div className="card-footer margin  ">
                    <a href="#!" 
                      className="btn btn-default "
                      data-toggle="pill"
                      onClick={onclick_Cancel}
                    >
                      <i className="fa  fa-times" /> Cancel
                    </a>
                    <a
                      href="#!"
                      data-toggle="pill"
                      className="btn btn-primary btn-block float-right col-sm-3"
                      onClick={onClick_Save}
                    >
                      <i className="fas  fa-save" /> Save
                    </a>
                  </div>
                  {/* end loading */}
                </div>
              </div>
            </div>
            <div className="row d-none">
              <div className="col-md-12">
                {/* The time line */}
                <div className="timeline">
                  {/*<div class="time-label">
                              <span class="bg-gray">Company</span>
                          </div>*/}
                  {/* timeline item */}
                  <div>
                    <i className="fas fa-tv bg-gray" />
                    <div className="timeline-item">
                      <span className="time">
                        <i className="fas fa-user" title="update" /> update:
                        admin 12/02/2023 12:05
                      </span>
                      <h3 className="timeline-header">Company xxxxx</h3>
                      <div className="timeline-body">
                        <div className="form-horizontal">
                          <div className="form-group row">
                            <label
                              htmlFor="inputName"
                              className="col-sm-2 col-form-label text-right"
                            >
                              xxx <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                id="inputName"
                                placeholder="Company display"
                                defaultValue="FLASHWORK TEAM CONSULTING CO.,LTD."
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputName2"
                              className="col-sm-2 col-form-label text-right"
                            >
                              xxx
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                id="inputName2"
                                placeholder="xxx"
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputExperience"
                              className="col-sm-2 col-form-label text-right"
                            >
                              xxx
                            </label>
                            <div className="col-sm-10">
                              <textarea
                                className="form-control form-control-sm"
                                id="inputExperience"
                                placeholder="xxx......"
                                defaultValue={""}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="offset-sm-2 col-sm-10">
                              <a href="#!" className="btn btn-primary">
                                <i className="fa  fa-save" /> Save
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* timeline item */}
                  <div>
                    <i className="fas fa-calendar-alt bg-gray" />
                    <div className="timeline-item">
                      <span className="time">
                        <i className="fas fa-user" title="update" /> update:
                        admin 12/02/2023 12:05
                      </span>
                      <h3 className="timeline-header">xxxx </h3>
                      <div className="timeline-body">
                        <div className="form-horizontal">
                          <div className="row">
                            <label
                              htmlFor="inputEmail"
                              className="col-sm-2 col-form-label text-right"
                            >
                              &nbsp;
                            </label>
                            <div className="col-sm-10">
                              <div className="row">
                                <div className="col-3 text-center">
                                  <span className="text-bold">
                                    Normal Hours{" "}
                                  </span>
                                  <small>(hr./day)</small>
                                </div>
                                <div className="col-3 text-center">
                                  <span className="text-bold">OT </span>
                                  <small>(hr./day)</small>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail"
                              className="col-sm-2 col-form-label text-right"
                            >
                              Working time
                            </label>
                            <div className="col-sm-10">
                              <div className="row">
                                <div className="col-lg-3 col-6">
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      placeholder=" Normal Hours"
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text text-sm">
                                        <small>hr.</small>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-3 col-6">
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      placeholder=" OT"
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text text-sm">
                                        <small>hr.</small>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-12 ">
                                  <div className="row">
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        defaultChecked
                                      />
                                      <label className="form-check-label text-sm ">
                                        Mon
                                      </label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        defaultChecked
                                      />
                                      <label className="form-check-label text-sm">
                                        Tue
                                      </label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        defaultChecked
                                      />
                                      <label className="form-check-label text-sm">
                                        Wed
                                      </label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        defaultChecked
                                      />
                                      <label className="form-check-label text-sm">
                                        Thu
                                      </label>
                                    </div>
                                    <div className="form-check ">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        defaultChecked
                                      />
                                      <label className="form-check-label text-sm">
                                        Fri
                                      </label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                      />
                                      <label className="form-check-label text-sm">
                                        Sat
                                      </label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                      />
                                      <label className="form-check-label text-sm">
                                        Sun
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail"
                              className="col-sm-2 col-form-label text-right"
                            >
                              Weekend
                            </label>
                            <div className="col-sm-10">
                              <div className="row">
                                <div className="col-lg-3 col-6">
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      placeholder=" Normal Hours"
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text text-sm">
                                        <small>hr.</small>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-3 col-6">
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      placeholder=" OT"
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text text-sm">
                                        <small>hr.</small>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-12 ">
                                  <div className="row">
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                      />
                                      <label className="form-check-label text-sm ">
                                        Mon
                                      </label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                      />
                                      <label className="form-check-label text-sm">
                                        Tue
                                      </label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                      />
                                      <label className="form-check-label text-sm">
                                        Wed
                                      </label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                      />
                                      <label className="form-check-label text-sm">
                                        Thu
                                      </label>
                                    </div>
                                    <div className="form-check ">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                      />
                                      <label className="form-check-label text-sm">
                                        Fri
                                      </label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        defaultChecked
                                      />
                                      <label className="form-check-label text-sm">
                                        Sat
                                      </label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        defaultChecked
                                      />
                                      <label className="form-check-label text-sm">
                                        Sun
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail"
                              className="col-sm-2 col-form-label text-right"
                            >
                              Holiday
                            </label>
                            <div className="col-sm-10">
                              <div className="row">
                                <div className="col-lg-3 col-6">
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      placeholder=" Normal Hours"
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text text-sm">
                                        <small>hr.</small>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-3 col-6">
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      placeholder=" OT"
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text text-sm">
                                        <small>hr.</small>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="offset-sm-2 col-sm-10">
                              <a href="#!" className="btn btn-primary">
                                <i className="fa  fa-save" /> Save
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* END timeline item */}
                  <div>
                    <i className="fas fa-clock bg-gray" />
                  </div>
                </div>
                {/* END timeline item */}
              </div>
            </div>
            {/* /.row (main row) */}
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}
    </>
  );
}



function ShowTimeLabel(props) {
  const { time } = props;

  return (
    <>
      {time === "" || time === "00:00" ? 
      <>
        <span className="span-lable text-bold mt-0 border p-1 bg-light">
          -
        </span>
      </>
        :  
      <>
        <span className="span-lable text-bold mt-0 border p-1 bg-light">
          {time.substring(0, 2) === "00" ? "" : 
          <>
            {time.substring(0, 1) === "0" ? 
                <>
                    {time.substring(1,2)}<span className="text-small">h</span>
                </> 
                : 
                <>
                    {time.substring(0, 2)}<span className="text-small">h</span>
                </>
            }
          </>
          }
          {time.substring(3) === "00" ? "" : 
          <>
            {" "}
            {time.substring(3)}<span className="text-small">m</span>
          </>
          }
        </span>
      </>
    }
    </>
  );
}


export default M_company_ae;
